function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.245 14.429l10.929-10.93-.133 9.837 1.785-.024L14 .429 1.117.603l-.025 1.784 9.837-.132L0 13.185l1.245 1.244z"
});

function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMjQ0NjcgMTQuNDI5TDEyLjE3MzkgMy40OTk2OUwxMi4wNDA1IDEzLjMzNTdMMTMuODI2MSAxMy4zMTE2TDE0IDAuNDI4OTU1TDEuMTE3MzYgMC42MDI4MTVMMS4wOTIwMSAyLjM4NzIxTDEwLjkyOTMgMi4yNTUwMkwwIDEzLjE4NDNMMS4yNDQ2NyAxNC40MjlaIiAvPgo8L3N2Zz4K";
export { SvgExternal as ReactComponent };